import { Bell, X } from "lucide-react";
import { useState } from "react";
import { usePush } from "../lib/usePush";
import { Button } from "./ui/button";

const DISMISSED = "montage.push.dismissed";

/**
 * «Включить уведомления» — монтажёрам и постановщикам (08.10.2026). Раньше
 * пуши получал только модератор, остальные — лишь Telegram, и то если
 * привязали бота.
 *
 * На iPhone пуш работает только в приложении с экрана «Домой» (iOS 16.4+), и
 * разрешение спрашивается по нажатию — поэтому кнопка, а не запрос сам по себе.
 */
export function PushPrompt() {
  const push = usePush();
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(DISMISSED) === "1"; } catch { return false; }
  });
  const dismiss = () => {
    setDismissed(true);
    try { localStorage.setItem(DISMISSED, "1"); } catch { /* только до перезагрузки */ }
  };

  const ios = typeof navigator !== "undefined" && /iPhone|iPad|iPod/.test(navigator.userAgent);
  const standalone = typeof window !== "undefined"
    && (window.matchMedia?.("(display-mode: standalone)").matches || (navigator as Navigator & { standalone?: boolean }).standalone === true);
  const denied = typeof Notification !== "undefined" && Notification.permission === "denied";

  if (dismissed || push.enabled || denied) return null;
  // iPhone в Safari: пушей нет вовсе, пока сайт не установлен как приложение.
  const needInstall = ios && !standalone;
  if (!needInstall && !push.supported) return null;

  return (
    <div className="flex items-center gap-3 rounded-[18px] border border-border bg-card px-4 py-3 text-sm">
      <Bell className="size-4 shrink-0 text-muted-foreground" />
      <span className="min-w-0 flex-1">
        {needInstall
          ? "Чтобы получать уведомления на iPhone, добавьте сайт на экран «Домой» (Поделиться → На экран «Домой») и откройте его оттуда."
          : "Уведомления о новых публикациях, правках и роликах на проверке — прямо в браузер и на телефон."}
        {push.error && <span className="block text-xs text-rework-fg">{push.error}</span>}
      </span>
      {!needInstall && (
        <Button size="sm" onClick={push.enable} disabled={push.busy}>
          Включить
        </Button>
      )}
      <button type="button" onClick={dismiss} title="Скрыть" className="grid size-7 shrink-0 place-items-center rounded-full text-muted-foreground hover:bg-muted">
        <X className="size-4" />
      </button>
    </div>
  );
}
